import { Reducer } from "redux";

import { CareCoordinationProgramResponse } from "../models/Api/Master";
import { CareCoordinationProgramDispatchTypes } from "../models/DispatchTypes/Master";
import { CareCoordinationProgramActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

export const initialState: CareCoordinationProgramResponse = {
  loading: false,
  response: [],
};

const CareCordinationReducer: Reducer<
  CareCoordinationProgramResponse,
  CareCoordinationProgramDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_SUCCESS: {
      setLocalStorageData(
        CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default CareCordinationReducer;
